function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
module.exports = function (clone, _ref) {
  var generateUUID = _ref.generateUUID,
    round = _ref.round;
  var getUnitCcPrice = function getUnitCcPrice(skuprice, skuqty, fraction) {
    return skuprice * (1 + fraction) / skuqty;
  };
  var _getPriceFn = function getPriceFn(item) {
    var addition = 0;
    if (_getPriceFn.withCcFee && vm.priceIncrease && item.priceTaxFeeAdjustments) {
      addition = item.priceTaxFeeAdjustments.reduce(function (t, v) {
        return t + (v.name === "feebuster" ? v.price : 0);
      }, 0) * (item.refund ? -1 : 1);
    }
    return (item.intPrice !== undefined ? item.intPrice : round(item.skuprice / item.skuqty * item.effectiveQuantity)) + addition;
  };
  _getPriceFn.withCcFee = true;
  var purchases = [];
  var drivertip = {
    cents: 0,
    coeff: null
  };
  var feeBusterConfig = {
    enabled: false,
    fraction: null,
    manualinclusive: false
  };
  var pointsExcludedDepts = [];
  var priceIncrease = false;
  var servicefee = {
    cents: 0,
    coeff: null
  };
  var tipsInformations = {
    cashtipsamt: 0,
    tips: null,
    tipsamt: 0,
    tipstype: null
  };

  // unique to shared lib
  var itemInit = function itemInit(item) {
    if (!item.uuid) {
      item.uuid = generateUUID();
    }
    if (!item.getPrice) {
      item.getPrice = function () {
        return _getPriceFn(item);
      };
    }

    // adjust for inconsistency: quantity of byweight items, when bought are recorded in the purchase object as 100ths of pounds, but in calculations, pounds are used
    // for example, in promos, both the qty and the maxamt are recorded in the promo object as pounds
    // so promos, discounts and overrides will use the effectiveQuantity field for calculations - centralized in a setter here so don't need to code everywhere that qty is adjusted or effectiveQuantity is required
    // must check typeof Object.getOwnPropertyDescriptor(item, 'qty').set and not p._qty as angularjs.copy kills getters / setters (happens when holding a basket) so when restoring a held basket we need to redefine the getter / setter
    if (typeof item.qty !== "undefined" && typeof Object.getOwnPropertyDescriptor(item, "qty").set === "undefined") {
      item._qty = item.qty;
      item.effectiveQuantity = item.byweight ? item.qty / 100 : item.qty;
      Object.defineProperty(item, "qty", {
        set: function set(x) {
          this._qty = x;
          this.effectiveQuantity = this.byweight ? this.qty / 100 : this.qty;
        },
        get: function get() {
          return this._qty;
        }
      });
    }
    if (item.dept == "Inside Gas Sales") {
      reg.gasPurchase = true;
    }
  };
  var addItem = function addItem(item) {
    if (_typeof(item.moreinfo) == "object") {
      Object.keys(item.moreinfo).forEach(function (key) {
        item[key] = item.moreinfo[key];
      });
    }
    itemInit(item);
    item.item_id = item.uuid;
    purchases.push(item);
  };
  var getCashPricePurchases = function getCashPricePurchases() {
    if (!vm.feeBusterConfig.enabled) {
      return purchases;
    }

    // beware! this may return a shorter list than purchaseService.purchases if an item has no feebuster Ptf
    var cashPricePurchases = [];
    purchases.forEach(function (a) {
      if (a.priceTaxFeeAdjustments) {
        var feeBusterPtf = a.priceTaxFeeAdjustments.find(function (a) {
          return a.name === "feebuster";
        });
        if (feeBusterPtf) {
          cashPricePurchases.push(feeBusterPtf.extra.cashPrice);
        }
      } else {
        cashPricePurchases.push(a);
      }
    });
    return cashPricePurchases;
  };
  var payments = [];
  // reg is mutated in doRecalcPurchases
  var reg = {
    fobid: "",
    custid: null,
    custbrmsg: "",
    brnumber: null,
    tok: null,
    itemcount: 0,
    verification: {
      age: null,
      mode: null
    },
    customer: {},
    final_weight: 0,
    age_verification: 0,
    closingbasket: false,
    racsVerification: {
      verified: false,
      override: false,
      reason: "",
      loginId: "",
      time: null
    },
    gasPurchase: false
  };
  var basket = null;
  var basketerror = [{
    status: "complete",
    msg: null
  }, {
    status: "weight_error",
    msg: "Some item needs to weight again."
  }];
  var clearpurchases = function clearpurchases() {
    purchases.length = 0;
    vm.totals.cached = {};
  };
  var clearpayments = function clearpayments() {
    payments.length = 0;
  };
  var clearTipsInformations = function clearTipsInformations() {
    vm.tipsInformations = {
      cashtipsamt: 0,
      tips: null,
      tipsamt: 0,
      tipstype: null
    };
  };
  function clearRegister() {
    clearpurchases();
    clearpayments();
    clearTipsInformations();
    vm.overrides = [];
    basket = null;
    reg.brbalance = 0;
    reg.brnumber = "";
    reg.fobid = "";
    reg.custid = null;
    reg.currentBasket = null;
    reg.customer = {};
    reg.closingbasket = false;
    reg.final_weight = 0;
    reg.verification = {
      age: null,
      mode: null
    };
    reg.racsVerification = {
      verified: false,
      override: false,
      reason: "",
      loginId: "",
      time: null
    };
    reg.gasPurchase = false;
  }
  reg.custbrmsg = "What is your BR Club Number?";
  var priceTaxFeeAdjusters = []; /* PTF */
  var isPointsExcludedDept = function isPointsExcludedDept(dept) {
    return vm.pointsExcludedDepts.indexOf(dept) !== -1;
  };
  var vm = {
    drivertip: drivertip,
    feeBusterConfig: feeBusterConfig,
    servicefee: servicefee,
    pointsExcludedDepts: pointsExcludedDepts,
    priceIncrease: priceIncrease,
    purchases: purchases,
    payments: payments,
    clearPurchases: clearpurchases,
    clearPayments: clearpayments,
    reg: reg,
    basket: basket,
    clearRegister: clearRegister,
    basketerror: basketerror,
    priceTaxFeeAdjusters: priceTaxFeeAdjusters /* PTF */,
    getPriceFn: _getPriceFn,
    getCashPricePurchases: getCashPricePurchases,
    addItem: addItem,
    // unique to shared lib
    tipsInformations: tipsInformations
  };
  vm.totals = {
    cached: {
      manualdiscountAndPriceoverrideItem: []
    },
    driverTip: function driverTip(cash) {
      if (typeof vm.totals.cached.driverTip === "undefined") {
        vm.totals.cached.driverTip = round(vm.drivertip.coeff ? vm.totals.subtotal(cash) * vm.drivertip.coeff : vm.drivertip.cents);
      }
      return vm.totals.cached.driverTip;
    },
    serviceFee: function serviceFee(cash) {
      if (typeof vm.totals.cached.serviceFee === "undefined") {
        vm.totals.cached.serviceFee = round(vm.servicefee.coeff ? vm.totals.subtotal(cash) * vm.servicefee.coeff + vm.servicefee.cents : vm.servicefee.cents);
      }
      return vm.totals.cached.serviceFee;
    },
    qty: function qty() {
      if (typeof vm.totals.cached.qty === "undefined") {
        vm.totals.cached.qty = purchases.filter(function (a) {
          return !a.refund && typeof a.upc !== "undefined";
        }).reduce(function (total, a) {
          return total + (a.byweight ? 1 : a.qty);
        }, 0);
      }
      return vm.totals.cached.qty;
    },
    promosItem: function promosItem(p, type) {
      if (!["promo", "coupons", "br"].includes(type)) {
        type = "total";
      }
      var promoTotal = 0;
      if (p.priceTaxFeeAdjustments) {
        for (var i2 = 0, ptf; ptf = p.priceTaxFeeAdjustments[i2]; ++i2) {
          if (ptf.name === "promo") {
            var promoPtf = ptf;
            var condition = true;
            if (type === "promo") {
              condition = !promoPtf.extra.promo.extpromoid && promoPtf.priority < 0;
            }
            if (type === "coupons") {
              condition = !promoPtf.extra.promo.extpromoid && promoPtf.priority > 0;
            }
            if (type === "br") {
              condition = promoPtf.extra.promo.extpromoid;
            }
            promoTotal += condition ? promo.price : 0;
          }
        }
      }
      return promoTotal;
    },
    promos: function promos(type, cash, forpoints) {
      if (!["promo", "coupons", "br"].includes(type)) {
        if (type) {
          console.error("Unrecognized promo type " + type);
        }
        type = "total";
      }
      if (type === "total") {
        return vm.totals.promos("promo", cash) + vm.totals.promos("coupons", cash) + vm.totals.promos("br", cash);
      }
      var suffix = (cash ? 'Cash' : '') + (forpoints ? 'forpoints' : '');
      if (vm.totals.cached["intPromoPriceTotals" + suffix] === undefined) {
        var purchaseList = cash ? getCashPricePurchases() : purchases;
        vm.refreshIntPromoPricelist({
          field: "intPromoPriceTotals" + suffix,
          purchaselist: purchaseList
        });
      }
      return vm.totals.cached["intPromoPriceTotals" + suffix][type];
    },
    promosCash: function promosCash(type) {
      if (!["promo", "coupons", "br"].includes(type)) {
        if (type) {
          console.error("Unrecognized promo type " + type);
        }
        type = "total";
      }
      if (type === "total") {
        return vm.totals.promosCash("promo") + vm.totals.promosCash("coupons") + vm.totals.promosCash("br");
      }
      if (vm.totals.cached.intPromoPriceTotalsCash === undefined) {
        vm.refreshIntPromoPricelist({
          field: "intPromoPriceTotalsCash",
          purchaselist: getCashPricePurchases()
        });
      }
      return vm.totals.cached.intPromoPriceTotalsCash[type];
    },
    manualdiscountAndPriceoverrideItem: function manualdiscountAndPriceoverrideItem(itemIndex) {
      var cash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var suffix = cash ? "Cash" : "";
      if (vm.totals.cached["manualdiscountAndPriceoverrideItem" + suffix] === undefined || typeof vm.totals.cached["manualdiscountAndPriceoverrideItem" + suffix][itemIndex] === "undefined") {
        var p = purchases[itemIndex];
        if (cash && p.priceTaxFeeAdjustments) {
          var feeBusterPtf = p.priceTaxFeeAdjustments.find(function (a) {
            return a.name === "feebuster";
          });
          if (feeBusterPtf) {
            p = feeBusterPtf.extra.cashPrice;
          }
        }
        var discountTotal = 0;
        if (p.priceTaxFeeAdjustments) {
          for (var i2 = 0, manualdiscountPtf; manualdiscountPtf = p.priceTaxFeeAdjustments[i2]; ++i2) {
            if (["manualdiscount", "priceoverride"].includes(manualdiscountPtf.name)) {
              discountTotal += manualdiscountPtf.price * (p.refund ? -1 : 1);
            }
          }
        }
        vm.totals.cached["manualdiscountAndPriceoverrideItem" + suffix] = vm.totals.cached["manualdiscountAndPriceoverrideItem" + suffix] || [];
        vm.totals.cached["manualdiscountAndPriceoverrideItem" + suffix][itemIndex] = discountTotal;
      }
      return vm.totals.cached["manualdiscountAndPriceoverrideItem" + suffix][itemIndex];
    },
    manualdiscountAndPriceoverride: function manualdiscountAndPriceoverride(cash, forpoints) {
      var suffix = (cash ? 'Cash' : '') + (forpoints ? 'forpoints' : '');
      if (typeof vm.totals.cached["manualdiscountAndPriceoverride" + suffix] === "undefined") {
        var discountTotal = 0;
        for (var i = 0; i < purchases.length; ++i) {
          if (!(forpoints && isPointsExcludedDept(purchases[i].dept))) {
            discountTotal += vm.totals.manualdiscountAndPriceoverrideItem(i, cash);
          }
        }
        vm.totals.cached["manualdiscountAndPriceoverride" + suffix] = discountTotal;
      }
      return vm.totals.cached["manualdiscountAndPriceoverride" + suffix];
    },
    getTotalsIrrespectiveOfAuthority: function getTotalsIrrespectiveOfAuthority(type) {
      var cash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!type) {
        throw new Error('getTotalsIrrespectiveOfAuthority requires a parameter of either "tax" or "fee"');
      }
      var suffix = cash ? "Cash" : "";
      if (vm.totals.cached["totalsIrrespectiveOfAuthority" + suffix] === undefined) {
        vm.totals.cached["totalsIrrespectiveOfAuthority" + suffix] = {
          tax: 0,
          fee: 0
        };
        var types = ["tax", "fee"];
        var purchaseList = cash ? getCashPricePurchases() : purchases;
        for (var i = 0, p; p = purchaseList[i]; ++i) {
          if (p.priceTaxFeeAdjustments) {
            var refundCoefficient = p.refund ? -1 : 1;
            for (var i2 = 0, ptf; ptf = p.priceTaxFeeAdjustments[i2]; ++i2) {
              for (var i3 = 0, _type; _type = types[i3]; ++i3) {
                if (ptf.name === _type) {
                  // *visible* taxes are only the ones not covered by a parallel decrease in price (= inclusive taxes)!
                  vm.totals.cached["totalsIrrespectiveOfAuthority" + suffix][_type] += (ptf[_type] + ptf.price) * refundCoefficient;
                }
              }
            }
          }
        }
        vm.totals.cached["totalsIrrespectiveOfAuthority" + suffix] = {
          tax: vm.totals.cached["totalsIrrespectiveOfAuthority" + suffix].tax,
          fee: vm.totals.cached["totalsIrrespectiveOfAuthority" + suffix].fee
        };
      }
      return vm.totals.cached["totalsIrrespectiveOfAuthority" + suffix][type];
    },
    tax: function tax(cash) {
      return vm.totals.auth("tax", cash);
    },
    fee: function fee(cash) {
      return vm.totals.auth("fee", cash);
    },
    auth: function auth(type) {
      var cash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var suffix = cash ? "Cash" : "";
      if (typeof vm.totals.cached[type + suffix] === "undefined") {
        var authSum = vm.totals.getTotalsIrrespectiveOfAuthority(type, cash);
        var authSum2 = 0;
        var purchaseList = cash ? getCashPricePurchases() : purchases;
        var _loop = function _loop(p) {
          if (p.priceTaxFeeAdjustments) {
            var authDiscount = +p.priceTaxFeeAdjustments.filter(function (a) {
              return a.name !== type;
            }).reduce(function (total, a) {
              return total + a[type] * (p.refund ? -1 : 1);
            }, 0);
            authSum2 += +authDiscount;
          }
        };
        for (var i = 0, p; p = purchaseList[i]; ++i) {
          _loop(p);
        }
        vm.totals.cached[type + suffix] = round(authSum + authSum2);
      }
      return vm.totals.cached[type + suffix];
    },
    modifierTotal: function modifierTotal(cash, forpoints) {
      var suffix = (cash ? 'Cash' : '') + (forpoints ? 'forpoints' : '');
      if (vm.totals.cached["modifierTotal" + suffix] === undefined) {
        vm.totals.cached["modifierTotal" + suffix] = 0;
        var purchaseList = cash ? getCashPricePurchases() : purchases;
        purchaseList.forEach(function (p) {
          (p.priceTaxFeeAdjustments || []).forEach(function (ptf) {
            if (ptf.name === 'itemModifierPTF' && !(forpoints && isPointsExcludedDept(p.dept))) {
              vm.totals.cached["modifierTotal" + suffix] += ptf.price * (p.refund ? -1 : 1);
            }
          });
        });
      }
      return vm.totals.cached["modifierTotal" + suffix];
    },
    positiveModifierTotal: function positiveModifierTotal() {
      if (vm.totals.cached.positiveModifierTotal === undefined) {
        vm.totals.cached.positiveModifierTotal = 0;
        purchases.forEach(function (p) {
          if (!p.refund && p.priceTaxFeeAdjustments) {
            p.priceTaxFeeAdjustments.forEach(function (ptf) {
              if (ptf.name === "itemModifierPTF") {
                vm.totals.cached.modifierTotal += ptf.price;
              }
            });
          }
        });
      }
      return vm.totals.cached.modifierTotal;
    },
    subtotal: function subtotal(cash, forpoints) {
      var suffix = (cash ? 'Cash' : '') + (forpoints ? 'forpoints' : '');
      if (vm.totals.cached["subtotal" + suffix] === undefined) {
        var totalPrice = 0;
        for (var i = 0, p; p = purchases[i]; ++i) {
          if (p.ispayment || typeof p.upc === 'undefined' || forpoints && isPointsExcludedDept(p.dept)) {
            continue;
          }
          totalPrice += cash ? p.intPrice : p.getPrice();
        }
        vm.totals.cached['subtotal' + suffix] = totalPrice + vm.totals.modifierTotal(cash, forpoints);
      }
      return vm.totals.cached["subtotal" + suffix];
    },
    positiveSubtotal: function positiveSubtotal() {
      if (typeof vm.totals.cached.positiveSubtotal === "undefined") {
        var totalPrice = 0;
        for (var i = 0, p; p = purchases[i]; ++i) {
          if (p.ispayment || p.refund || p.upc === undefined) {
            continue;
          }
          totalPrice += p.getPrice();
        }
        vm.totals.cached.positiveSubtotal = totalPrice;
      }
      return vm.totals.cached.positiveSubtotal + vm.totals.positiveModifierTotal();
    },
    totalPtfPriceWithExclusions: function totalPtfPriceWithExclusions() {
      var cash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var suffix = cash ? "Cash" : "";
      if (typeof vm.totals.cached["totalPtfPriceWithExclusions" + suffix] === "undefined") {
        var totalPtfPrice = 0;
        // we don't use the exact promo PTFs but rather the rounded ones and they are the ones that have the final word
        // any price values in tax and fee PTFs are only to offset the tax / fee in a case of an implicit charge so these are excluded from price summations
        // modifiers have their own summing function
        // finally, we don't use the feebuster PTFs because they are rolled into the base item price using item.getPrice
        var exclusions = ["promo", "fee", "tax", "itemModifierPTF", "feebuster"];
        for (var i = 0, p; p = (cash ? getCashPricePurchases() : purchases)[i]; ++i) {
          if (p.ispayment || typeof p.upc === "undefined") {
            continue;
          }
          if (p.priceTaxFeeAdjustments) {
            for (var i2 = 0, ptf; ptf = p.priceTaxFeeAdjustments[i2]; ++i2) {
              if (!exclusions.includes(ptf.name)) {
                totalPtfPrice += ptf.price * (p.refund ? -1 : 1);
              }
            }
          }
        }
        vm.totals.cached["totalPtfPriceWithExclusions" + suffix] = totalPtfPrice;
      }
      return vm.totals.cached["totalPtfPriceWithExclusions" + suffix];
    },
    totalPtfPrice: function totalPtfPrice() {
      var cash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var suffix = cash ? "Cash" : "";
      if (typeof vm.totals.cached["totalPtfPrice" + suffix] === "undefined") {
        vm.totals.cached["totalPtfPrice" + suffix] = vm.totals.promos(null, cash) + vm.totals.totalPtfPriceWithExclusions(cash);
      }
      return vm.totals.cached["totalPtfPrice" + suffix];
    },
    totalDues: function totalDues() {
      var cash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var suffix = cash ? "Cash" : "";
      var tipsamt = cash ? vm.tipsInformations.cashtipsamt : vm.tipsInformations.tipsamt;
      if (vm.totals.cached["totalDues" + suffix] === undefined) {
        vm.totals.cached["totalDues" + suffix] = vm.totals.totalPtfPrice(cash) + vm.totals.subtotal(cash) + vm.totals.driverTip(cash) + vm.totals.serviceFee(cash) + vm.totals.tax(cash) + vm.totals.fee(cash) + tipsamt;
      }
      return vm.totals.cached["totalDues" + suffix];
    },
    totalCoupons: function totalCoupons() {
      if (typeof vm.totals.cached.totalCoupons === "undefined") {
        var couponPayment = payments.filter(function (a) {
          return a.paytype === "Coupon" && !(a.extradata && a.extradata.ptdisc);
        }) // Coupon payments of type "ptdisc" are already counted in "promos"
        .reduce(function (total, a) {
          return total + a.cents;
        }, 0);
        vm.totals.cached.totalCoupons = couponPayment ? -couponPayment : 0;
      }
      return vm.totals.cached.totalCoupons;
    },
    totalPayment: function totalPayment() {
      if (typeof vm.totals.cached.totalPayment === "undefined") {
        vm.totals.cached.totalPayment = vm.totals.totalPaymentCalc();
      }
      return vm.totals.cached.totalPayment;
    },
    totalPaymentCalc: function totalPaymentCalc() {
      var totalPayment = 0;
      for (var i = 0, pm; pm = payments[i]; ++i) {
        if (!pm.ignore && pm.paytype !== "Coupon") {
          totalPayment += pm.cents;
        }
      }
      return -totalPayment;
    },
    totalSpentForPoints: function totalSpentForPoints(cash) {
      return vm.totals.subtotal(cash, true) + vm.totals.manualdiscountAndPriceoverride(cash, true) + vm.totals.promos(null, cash, true);
    },
    ccUsed: function ccUsed() {
      if (vm.totals.cached.ccUsed === undefined) {
        vm.totals.cached.ccUsed = payments.find(function (a) {
          return ["Credit/Debit", "epay"].includes(a.paytype);
        });
      }
      return vm.totals.cached.ccUsed;
    },
    customertabUsed: function customertabUsed() {
      if (vm.totals.cached.ccUsed === undefined) {
        vm.totals.cached.ccUsed = payments.find(function (a) {
          return a.paytype === "Customer Tab";
        });
      }
      return vm.totals.cached.ccUsed;
    },
    epaidUsed: function epaidUsed() {
      if (vm.totals.cached.epaidUsed === undefined) {
        vm.totals.cached.epaidUsed = payments.find(function (a) {
          return a.paytype === "epaid";
        });
      }
      return vm.totals.cached.epaidUsed;
    },
    allPaidByCash: function allPaidByCash() {
      if (vm.totals.cached.allPaidByCash === undefined) {
        vm.totals.cached.allPaidByCash = (reg.closingbasket && vm.totals.total("cash") < 0 || vm.totals.total("cash") === 0) && !vm.totals.ccUsed() && !vm.totals.customertabUsed() && !vm.totals.epaidUsed();
      }
      return vm.totals.cached.allPaidByCash;
    },
    useLowerItemPrices: function useLowerItemPrices() {
      return vm.totals.allPaidByCash() && (!vm.priceIncrease || vm.feeBusterConfig.enabled);
    },
    total: function total() {
      var cash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var suffix = cash && !vm.totals.ccUsed() && !vm.totals.customertabUsed() && !vm.totals.epaidUsed() && (!vm.priceIncrease || vm.feeBusterConfig.enabled) ? "Cash" : "";
      if (vm.totals.cached["total" + suffix] === undefined) {
        vm.totals.cached["total" + suffix] = vm.totals.totalDues(suffix) + vm.totals.totalCoupons() + vm.totals.totalPayment();
      }
      return vm.totals.cached["total" + suffix];
    },
    totalBrCouldSaveList: function totalBrCouldSaveList() {
      if (typeof vm.totals.cached.totalBrCouldSaveList === "undefined") {
        vm.totals.cached.totalBrCouldSaveList = -vm.getBrCouldSaveList().reduce(function (total, a) {
          return total + (a ? a.cents : 0);
        }, 0);
      }
      return vm.totals.cached.totalBrCouldSaveList;
    }
    /*
    taxReductionSource: function () {
      // UI/view only function from POS (unused in SL)
      if (typeof vm.totals.cached.taxReductionSource === "undefined") {
        var taxReductionSource = null;
         for (var p of purchases) {
          if (p.priceTaxFeeAdjustments) {
            var taxReducedPtf = p.priceTaxFeeAdjustments.find(
              (b) => ["ebt", "ewic", "wic"].includes(b.name) && b.tax < 0,
            );
             if (taxReducedPtf) {
              taxReductionSource = taxReducedPtf.name.toUpperCase();
              break;
            }
          }
        }
        vm.totals.cached.taxReductionSource = taxReductionSource;
      }
       return vm.totals.cached.taxReductionSource;
    },
    taxReductionSourceDisplay: function () {
      // UI/view only function from POS (unused in SL)
      if (vm.totals.cached.taxReductionSourceDisplay === undefined) {
        vm.totals.cached.taxReductionSourceDisplay = "";
         if (vm.priceTaxFeeAdjusters.find((a) => a.name === "taxfreesale")) {
          if (vm.basket) {
            vm.totals.cached.taxReductionSourceDisplay = "FREE";
          }
        } else {
          let taxReductionSource = vm.totals.taxReductionSource();
          vm.totals.cached.taxReductionSourceDisplay = taxReductionSource
            ? taxReductionSource + " Reduced"
            : "";
        }
      }
       return vm.totals.cached.taxReductionSourceDisplay;
    },
    */
  };
  vm.getIntPricelist = function () {
    if (vm.totals.cached.intPrices === undefined) {
      vm.totals.cached.intPrices = [];
      var floatPriceSums = {};
      var floatCcPriceSums = {};
      var intPriceSums = {};
      var intCcPriceSums = {};
      purchases.forEach(function (p) {
        if (p.ispayment || typeof p.upc === "undefined") {
          var intPrice = p.price * (p.refund ? -1 : 1);
        } else {
          var unitPrice = p.skuprice / p.skuqty;
          var floatPrice = unitPrice * p.effectiveQuantity * (p.refund ? -1 : 1);
          var intPrice = round(floatPrice);
          floatPriceSums[p.upc] = floatPriceSums[p.upc] || 0;
          floatPriceSums[p.upc] += floatPrice;
          var totalFloatPrice = floatPriceSums[p.upc];
          intPriceSums[p.upc] = intPriceSums[p.upc] || 0;
          var totalIntPrice = intPriceSums[p.upc] + intPrice; // we don't yet add the intprice here as it's not yet final!
          var cumulativeDiscrepancy = round(totalIntPrice - totalFloatPrice);
          if (cumulativeDiscrepancy * Math.sign(cumulativeDiscrepancy) >= 1) {
            intPrice -= cumulativeDiscrepancy;
          }
          intPriceSums[p.upc] += intPrice;
          if (vm.priceIncrease) {
            var unitCcPrice = getUnitCcPrice(p.skuprice, p.skuqty, vm.feeBusterConfig.fraction);

            // if item price is integer so feebuster augmented price must also be integer to prevent
            // discrepancy between lines of same item, caused by fractional overflow
            if (Number.isInteger(unitPrice)) {
              unitCcPrice = round(unitCcPrice);
            }
            var floatCcPrice = unitCcPrice * p.effectiveQuantity * (p.refund ? -1 : 1);
            var intCcPrice = round(floatCcPrice);
            floatCcPriceSums[p.upc] = floatCcPriceSums[p.upc] || 0;
            floatCcPriceSums[p.upc] += floatCcPrice;
            var totalFloatCcPrice = floatCcPriceSums[p.upc];
            intCcPriceSums[p.upc] = intCcPriceSums[p.upc] || 0;
            var totalIntCcPrice = intCcPriceSums[p.upc] + intCcPrice; // we don't yet add the intprice here as it's not yet final!
            var cumulativeDiscrepancy = round(totalIntCcPrice - totalFloatCcPrice);
            if (cumulativeDiscrepancy * Math.sign(cumulativeDiscrepancy) >= 1) {
              intCcPrice -= cumulativeDiscrepancy;
            }
            intCcPriceSums[p.upc] += intCcPrice;
          }
        }
        p.intPrice = intPrice;
        p.intCcPrice = intCcPrice;
        vm.totals.cached.intPrices.push(intPrice);
      });
    }
    return vm.totals.cached.intPrices;
  };

  // populates an external array of total promo price benefits
  vm.refreshIntPromoPricelist = function (list) {
    if (typeof vm.totals.cached[list.field] === "undefined") {
      vm.totals.cached[list.field] = {
        promo: 0,
        br: 0,
        coupons: 0
      };
      list.purchaselist.forEach(function (p) {
        if (p.priceTaxFeeAdjustments && !(list.field.indexOf('forpoints') !== -1 && isPointsExcludedDept(p.dept))) {
          p.priceTaxFeeAdjustments.forEach(function (a) {
            if (a.name === "promo") {
              if (!a.extra.promo.extpromoid && a.priority < 0) {
                vm.totals.cached[list.field].promo += a.price * (p.refund ? -1 : 1);
              }
              if (!a.extra.promo.extpromoid && a.priority > 0) {
                vm.totals.cached[list.field].coupons += a.price * (p.refund ? -1 : 1);
              }
              if (a.extra.promo.extpromoid) {
                vm.totals.cached[list.field].br += a.price * (p.refund ? -1 : 1);
              }
            }
          });
        }
      });
    }
  };
  vm.getBrCouldSaveList = function (itemIndex) {
    if (vm.reg.brnumber) {
      return [];
    }
    if (typeof vm.totals.cached.brCouldSaveList === "undefined") {
      // work on a dummy copy
      vm.totals.cached.brCouldSaveList = clone(purchases);
      // clean out all products' priceTaxFeeAdjustments
      vm.totals.cached.brCouldSaveList.forEach(function (a) {
        return a.priceTaxFeeAdjustments = [];
      });
      // just add the promos; calculatePotentialBrOnly makes sure to only add the BR promos
      vm.priceTaxFeeAdjusters.filter(function (a) {
        return a.name === "promo";
      }).forEach(function (a) {
        return a.calculatePotentialBrOnly(vm.totals.cached.brCouldSaveList);
      });
      vm.totals.cached.brCouldSaveList.forEach(function (a, index) {
        if (a.priceTaxFeeAdjustments.length) {
          vm.totals.cached.brCouldSaveList[index] = {
            extpromoid: a.priceTaxFeeAdjustments.map(function (a) {
              return a.extra.promo.extpromoid;
            }).join(","),
            cents: a.priceTaxFeeAdjustments.reduce(function (total, a) {
              return total + a.price;
            }, 0)
          };
        } else {
          vm.totals.cached.brCouldSaveList[index] = null;
        }
      });
    }
    return itemIndex ? vm.totals.cached.brCouldSaveList[itemIndex] : vm.totals.cached.brCouldSaveList;
  };
  vm.getCoffeeclubList = function (itemIndex) {
    if (typeof vm.totals.cached.coffeeclubList === "undefined") {
      vm.totals.cached.coffeeclubList = {};
      purchases.forEach(function (a) {
        if (a.upc) {
          vm.totals.cached.coffeeclubList[a.uuid] = vm.clubListUpcLookup[a.upc];
        }
      });
    }
    return itemIndex ? vm.totals.cached.coffeeclubList[itemIndex] : vm.totals.cached.coffeeclubList;
  };
  //-----------------------------------------------------------------------
  vm.getIndex = function (uuid) {
    return purchases.findIndex(function (a) {
      return a.uuid === uuid;
    });
  };
  //------------------------------------------------------------------------
  vm.deletePTF = function (uuid, id) {
    vm.priceTaxFeeAdjusters = vm.priceTaxFeeAdjusters.filter(function (a) {
      return a.name != "itemModifierPTF" || a.uuid !== uuid || a.id != id;
    });
    return vm.priceTaxFeeAdjusters;
  };
  //----------------------------------------------------------------------
  vm.calculateModifiersStatus = function (uuid, groupList) {
    var item = purchases.find(function (a) {
      return a.uuid === uuid;
    });
    item.modifierStatus = {};
    var ptfList = typeof item.priceTaxFeeAdjustments != "undefined" ? item.priceTaxFeeAdjustments.filter(function (a) {
      return a.name === "itemModifierPTF";
    }) : [];
    var addedListCnt = {};
    groupList.forEach(function (group) {
      addedListCnt[group.modifier_group] = 0;
    });
    ptfList.forEach(function (ptf) {
      if (typeof addedListCnt[ptf.extra.group] != "undefined") {
        addedListCnt[ptf.extra.group]++;
      } else addedListCnt[ptf.extra.group] = 1;
    });
    item.modifierStatus.cancel = false;
    groupList.forEach(function (group) {
      item.modifierStatus[group.modifier_group] = {
        min: addedListCnt[group.modifier_group] >= group.min_required || group.min_required === null,
        max: addedListCnt[group.modifier_group] < group.max_allowed || group.max_allowed === null
      };
      if (item.modifierStatus[group.modifier_group].min === false) {
        item.modifierStatus.cancel = true;
      }
    });
    return item.modifierStatus;
  };
  return vm;
}(require("clone"), require("./utils.js"));